module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/pins/early_years-5635bd1e3dbdf1f9705a2bee2792fc77.svg";